import React, { Component } from 'react';
import { connect } from 'react-redux';
import { NavItem } from 'reactstrap';

import { requestReindex } from '../../ducks/reindexDB';
import { SecureContent } from 'core/components';
import * as roles from 'core/model/roles';

class ReindexDB extends Component {

	render() {
		const { pending, dispatch, minimal, ...other } = this.props;
		const icon = pending ? "fa fa-spin fa-retweet mt-2 text-info" : "fa fa-retweet mt-2 text-info";
		return (
			<SecureContent role={roles.ADMIN}>
				<NavItem {...other} minimal={minimal.toString()} className="d-md-down-none">
					<i
						className={icon}
						title="Re-index database."
						role="link"
						onClick={() => {
							if (!pending) {
								dispatch( requestReindex() )
							}
						}}
					/>
				</NavItem>
			</SecureContent>
		);
	}
}

const mapStateToProps = (state) => ({
	pending: state.reindexDB.pending,
});

ReindexDB = connect(mapStateToProps)(ReindexDB);

export default ReindexDB;
